import { select, all, call, fork, put, takeEvery, getContext } from 'redux-saga/effects';

import * as api from '../../api/api';
import * as actions from './actions';
import { DataActionTypes } from './types';
import { getStudent, getUI } from '../selectors';
import { StudentState } from '../student/types';
import { logout } from '../auth/actions';
import { UIState } from '../ui/types';

function* handleGetUploadUrl(action: ReturnType<typeof actions.getUploadUrl>) {
  try {
    const student: StudentState = yield select(getStudent);
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired');
      return;
    }

    const [uni, studentNo] = student.core.student_id.split('#');

    const { intakeId, offerId } = student.offer;

    const { data } = yield call(api.getUploadUrl, idToken, uni, studentNo, intakeId, offerId, {
      openModal: action.payload.openModal,
      fileName: action.payload.fileName,
      fileType: action.payload.fileType
    });
    yield put(actions.uploadFile(action.payload.file, data));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getUploadUrlFailure(err.message));
    } else {
      yield put(actions.getUploadUrlFailure('An unknown error occured.'));
    }
  }
}

function* handleUploadFile(action: ReturnType<typeof actions.uploadFile>) {
  try {
    const { file, url } = action.payload;

    yield call(api.uploadFile, file, url);

    const ui: UIState = yield select(getUI);
    const student: StudentState = yield select(getStudent);

    const { sponsorType, sponsorKey, docType, docKey, fileNames, isFinanceDocumentModal, isFollowUpModal } =
      ui.openModal || {};

    yield put(
      actions.uploadFileSuccess(
        sponsorType ?? null,
        sponsorKey ?? null,
        docType ?? null,
        docKey ?? null,
        fileNames ?? [],
        isFinanceDocumentModal || false,
        isFollowUpModal || false,
        student.financials
      )
    );
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.uploadFileFailure(err.message));
    } else {
      yield put(actions.uploadFileFailure('An unknown error occured.'));
    }
  }
}

function* watchFileUpload() {
  yield takeEvery(DataActionTypes.GET_UPLOAD_FILE_URL, handleGetUploadUrl);

  yield takeEvery(DataActionTypes.UPLOAD_FILE, handleUploadFile);
}

function* DataSaga() {
  yield all([fork(watchFileUpload)]);
}

export default DataSaga;
